export default "__VITE_ASSET__BWUwnuxn__"